export const required = (condition, error) => {
  if (!condition) {
    throw error;
  }
};
